/* globals ServerFormater, XmlElement, DATA_STATE_CLEAN, DATA_STATE_DIRTY */
/* eslint-disable new-cap */
function GlobalObjective (
    Index,
    ID,
    ObjectiveProgressStatus,
    SatisfiedStatus,
    MeasureStatus,
    NormalizedMeasure,
    ScoreRaw,
    ScoreMin,
    ScoreMax,
    CompletionStatus,
    CompletionStatusValue,
    ProgressMeasureStatus,
    ProgressMeasure
) {
    Debug.AssertError("Global Objective not created with all parameters (is the call missing the index?).", typeof NormalizedMeasure === "undefined" || NormalizedMeasure === null);

    this.Index = Index;
    this.ID = ID;
    this.ProgressStatus = ObjectiveProgressStatus || false;
    this.SatisfiedStatus = SatisfiedStatus || false;
    this.MeasureStatus = MeasureStatus || false;
    this.NormalizedMeasure = NormalizedMeasure || 0.0;

    this.ScoreRaw = typeof ScoreRaw === "undefined" ? null : ScoreRaw;
    this.ScoreMin = typeof ScoreMin === "undefined" ? null : ScoreMin;
    this.ScoreMax = typeof ScoreMax === "undefined" ? null : ScoreMax;
    this.CompletionStatus = CompletionStatus || false;
    this.CompletionStatusValue = CompletionStatusValue || false;
    this.ProgressMeasureStatus = ProgressMeasureStatus || false;
    this.ProgressMeasure = typeof ProgressMeasure === "undefined" ? null : ProgressMeasure;

    this.DataState = DATA_STATE_CLEAN;
}

GlobalObjective.prototype = {
    GetXml: function (registrationId) {
        var ServerFormat = new ServerFormater(),
            xml = new XmlElement("GO");

        xml.AddAttribute("RI", registrationId);
        xml.AddAttribute("ROI", this.Index);
        xml.AddAttribute("I", this.ID);
        xml.AddAttribute("PS", ServerFormat.ConvertBoolean(this.ProgressStatus));
        xml.AddAttribute("SS", ServerFormat.ConvertBoolean(this.SatisfiedStatus));
        xml.AddAttribute("MS", ServerFormat.ConvertBoolean(this.MeasureStatus));
        xml.AddAttribute("NM", this.NormalizedMeasure);
        xml.AddAttribute("CS", ServerFormat.ConvertBoolean(this.CompletionStatus));
        xml.AddAttribute("CSV", ServerFormat.ConvertBoolean(this.CompletionStatusValue));

        if (this.ScoreRaw !== null) {
            xml.AddAttribute("SR", this.ScoreRaw);
        }
        if (this.ScoreMax !== null) {
            xml.AddAttribute("SM", this.ScoreMax);
        }
        if (this.ScoreMin !== null) {
            xml.AddAttribute("SMi", this.ScoreMin);
        }

        xml.AddAttribute("PrMS", ServerFormat.ConvertBoolean(this.ProgressMeasureStatus));
        if (this.ProgressMeasure !== null) {
            xml.AddAttribute("PM", this.ProgressMeasure);
        }

        return xml.toString();
    },

    Clone: function () {
        return new GlobalObjective(
            this.Index,
            this.ID,
            this.ProgressStatus,
            this.SatisfiedStatus,
            this.MeasureStatus,
            this.NormalizedMeasure,
            this.ScoreRaw,
            this.ScoreMin,
            this.ScoreMax,
            this.CompletionStatus,
            this.CompletionStatusValue,
            this.ProgressMeasureStatus,
            this.ProgressMeasure
        );
    },

    SetDirtyData: function () {
        this.DataState = DATA_STATE_DIRTY;
    },

    ResetState: function () {
        this.ProgressStatus = false;
        this.SatisfiedStatus = false;
        this.MeasureStatus = false;
        this.NormalizedMeasure = 0;
        this.ScoreRaw = null;
        this.ScoreMin = null;
        this.ScoreMax = null;
        this.CompletionStatus = false;
        this.CompletionStatusValue = false;
        this.ProgressMeasureStatus = false;
        this.ProgressMeasure = null;

        this.SetDirtyData();
    }
};
